export const PostionalMediaActions = {
    UPDATE_POSITIONAL_MEDIA_POSITION: 'InteractiveElements.UPDATE_POSITIONAL_MEDIA_POSITION',
    REGISTER_POSITIONAL_MEDIA: 'InteractiveElements.REGISTER_POSITIONAL_MEDIA',
    UNREGISTER_POSITIONAL_MEDIA: 'InteractiveElements.UNREGISTER_POSITIONAL_MEDIA',
    SET_POSITIONAL_MEDIA_STATUS: 'InteractiveElements.SET_POSITIONAL_MEDIA_STATUS',
    SET_POSITIONAL_MEDIA_PROGRESS: 'InteractiveElements.SET_POSITIONAL_MEDIA_PROGRESS',
    RESET: 'InteractiveElements.RESET',
    PAUSING: 'InteractiveElements.PAUSING',
    PAUSED: 'InteractiveElements.PAUSED',
}

export const MediaStates = {
    PLAY: 'play',
    PAUSE: 'pause',
    REPLAY: 'replay',
}

export const InteractiveListStates = {
    EXPANDED: 'expanded',
    MINIMIZED: 'minimized',
    HIDDEN: 'hidden',
}

export const HotspotStates = {
    DEFAULT: 'default',
    PANNING: 'panning',
    VISITED: 'visited',
}

export const INTERACTIVE_ELEMENT_OPTIONS = {
    //Used to differentiate between our types of elements
    ELEMENT_TYPE: {
        hotspot: 'hotspot',
        trigger: 'trigger',
        positionalMedia: 'positionalMedia',
        payment: 'payment',
    },
    //Used to differentiate between 3d and 2d context
    CONTEXT: {
        //Draws the element on a photo
        context2D: 'context2D',
        //Draws the element on a pano
        context3D: 'context3D',
    },
    MODE: {
        //State used for the viewer only
        view: 'view',
        //State used for viewing in the builder
        build: 'build',
        //State used for editing in the builder
        edit: 'edit',
    },
}

export const InteractiveElementActions = {
    SET_OPEN_TRIGGER: '|A|InteractiveElements.SET_OPEN_TRIGGER',
    CLOSE_HOTSPOT_MODAL: 'InteractiveElements.CLOSE_HOTSPOT_MODAL',
    OPEN_HOTSPOT_MODAL: '|A|InteractiveElements.OPEN_HOTSPOT_MODAL',
    TRIGGER_MOUSE_ENTERED: '|A|InteractiveElements.TRIGGER_MOUSE_ENTERED',
    TRIGGER_CLICKED: '|A|InteractiveElements.TRIGGER_CLICKED',
    SET_TRIGGERS: 'InteractiveElements.SET_TRIGGERS',
    SET_POSITIONAL_MEDIA: 'InteractiveElements.SET_POSITIONAL_MEDIA',
    SET_HOTSPOTS: 'InteractiveElements.SET_HOTSPOTS',
    SET_PAYMENT_HOTSPOTS: 'InteractiveElements.SET_PAYMENT_HOTSPOTS',
    SET_HOTSPOT_COORDINATES: '|A|InteractiveElements.SET_HOTSPOT_COORDINATES',
}

export const CommonActionTypes = {
    SET_VISITED: 'SET_VISITED',
    SET_PREVIEW: 'SET_PREVIEW',
    ADD_ELEMENT: 'ADD_ELEMENT',
    EDIT_ELEMENT: 'EDIT_ELEMENT',
    DELETE_ELEMENT: 'DELETE_ELEMENT',
    HYDRATE_INTERACTIVE: 'HYDRATE_INTERACTIVE',
    OPEN_PREVIEW: 'InteractiveElements.OPEN_PREVIEW',
    CLOSE_PREVIEW: 'InteractiveElements.CLOSE_PREVIEW',
    OPEN_MODAL: 'InteractiveElements.OPEN_MODAL',
    CLOSE_MODAL: 'InteractiveElements.CLOSE_MODAL',
    SET_SCENE: 'InteractiveElements.SET_SCENE',
    FORCE_MEDIA_PAUSE: 'InteractiveElements.FORCE_MEDIA_PAUSE',
    SET_DRAG_HINT_DETAILS: 'InteractiveElements.SET_DRAG_HINT_DETAILS',
}

export const Breakpoints = {
    DisplayPreviewWidthEmbedded: 1110,
}
